/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {useSelector} from "react-redux";
import {service as SpeciesService} from "../../../Services/SpeciesService";
import {service as SpeciesTypeService} from "../../../Services/SpeciesTypeService";
import {ServiceDrivenAutoCompleteFieldEditor} from "../../../Models/Core/FieldEditors/ServiceDrivenAutoCompleteFieldEditor";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";


const _SpeciesFieldEditor = ServiceDrivenAutoCompleteFieldEditor(SpeciesService);

export const SpeciesFieldEditor = (props) => {
	
	usePrimeCache(SpeciesTypeService);
	
	const {speciesTypeId, speciesNativityId, speciesInvasivityId} = props;
	const context = useSelector(state => state.contextState.context);
	const speciesTypeTitle = SpeciesTypeService.CachedTitleById(speciesTypeId) ?? 'results';
	
	return <_SpeciesFieldEditor
		context={context}
		emptyMessage={`No matching ${speciesTypeTitle}`}
		{...props}
		additionalSearchParams={{
			speciesTypeId,
			speciesNativityId,
			speciesInvasivityId,
		}}
	/>
	
}

